import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import React, { Fragment, FunctionComponent } from "react";
import BackgroundTheme from "../components/Intro/BackgroundTheme";

const SelectTemplate = ({ open, onClose }) => {
  if (!open) return <span></span>;
  return (
    <div id="overlay">
      <div className=" relative" style={{ width: "40%" }}>
        <div
          onClick={() => onClose()}
          className="bg-red-500 rounded-full text-white h-8 cursor-pointer hover:bg-red-600 w-8 flex justify-center items-center absolute right-0"
        >
          <span className="fa fa-times"></span>
        </div>
        <img
          src={require("../assest/overlayIntro.png")}
          style={{ width: "100%" }}
        />
      </div>
    </div>
  );
};

export default SelectTemplate;
